import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  IconButton,
  InputAdornment,
  Popover,
  TextField,
  Typography
} from '@mui/material';

import { CloseOutlined, SearchOutlined } from '@mui/icons-material';

import {
  noPatientsTextSx,
  noPatientsWrapperSx,
  patientDetailsSx,
  patientListItemSx,
  patientListSx,
  patientNameSx,
  patientSearchFooterSx,
  patientSearchFooterTextSx,
  patientSearchIconSx,
  patientSearchInputWrapperSx,
  patientSearchPopoverPaperSx
} from '../../Common/components/Styles/PatientPageStyles';

import {
  dialogHeaderStyles,
  searchFieldSx
} from '../../Common/components/Styles/InputStyles';

const PatientSearchPopover = ({
  anchorEl,
  open,
  patients,
  search,
  onSearchChange,
  onClose,
  onSelectPatient
}) => {
  const filteredPatients = patients.filter(patient =>
    `${patient.name} ${patient.mr}`
      .toLowerCase()
      .includes(search.trim().toLowerCase())
  );

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}
      slotProps={{
        paper: {
          sx: patientSearchPopoverPaperSx
        }
      }}>
      <Box sx={dialogHeaderStyles.dialogheader}>
        <Box>
          <Typography sx={dialogHeaderStyles.title}>Patient</Typography>

          <Typography sx={dialogHeaderStyles.subtitle}>
            Search for a patient to open a SOAP note.
          </Typography>
        </Box>

        <IconButton
          onClick={onClose}
          size="small"
          sx={dialogHeaderStyles.dialogheaderclose}>
          <CloseOutlined
            sx={{
              fontSize: 18,
              color: '#616161'
            }}
          />
        </IconButton>
      </Box>

      <Box sx={patientSearchInputWrapperSx}>
        <TextField
          fullWidth
          size="small"
          value={search}
          onChange={onSearchChange}
          placeholder="Search by name or MR#..."
          sx={searchFieldSx}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <SearchOutlined sx={patientSearchIconSx} />
                </InputAdornment>
              )
            }
          }}
        />
      </Box>

      <Box sx={patientListSx}>
        {filteredPatients.length > 0 ? (
          filteredPatients.map(patient => (
            <Box
              key={patient.mr}
              onClick={() => onSelectPatient(patient)}
              sx={patientListItemSx}>
              <Typography sx={patientNameSx}>{patient.name}</Typography>

              <Typography sx={patientDetailsSx}>
                MR# {patient.mr} &nbsp;•&nbsp;
                {patient.dob} &nbsp;•&nbsp;
                {patient.sex}
              </Typography>
            </Box>
          ))
        ) : (
          <Box sx={noPatientsWrapperSx}>
            <Typography sx={noPatientsTextSx}>No patients found</Typography>
          </Box>
        )}
      </Box>

      <Box sx={patientSearchFooterSx}>
        <Typography sx={patientSearchFooterTextSx}>
          Organisation has {patients.length} patients
        </Typography>
      </Box>
    </Popover>
  );
};

PatientSearchPopover.propTypes = {
  anchorEl: PropTypes.object,
  open: PropTypes.bool.isRequired,
  patients: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      mr: PropTypes.string.isRequired,
      dob: PropTypes.string.isRequired,
      sex: PropTypes.string.isRequired
    })
  ).isRequired,
  search: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelectPatient: PropTypes.func.isRequired
};

PatientSearchPopover.defaultProps = {
  anchorEl: null
};

export default PatientSearchPopover;
